import styled from "styled-components";
import { Card, Cards, CardContainer } from "./CommonComponents";
import { Star } from "./svgs";
import contents from '../utills/page_contents.json'

const Section = styled.div`
  display: flex;
  margin-bottom: 20px;
  @media (max-width: 1024px) {
    flex-direction: column;
  } ;
`;

const Title = styled.h1`
  font-size: 0.9rem;
  font-weight: 600;
`;

const Annotation = styled.div`
  position: absolute;
  right: 5%;
  top: 0;
  font-size: 0.8rem;
  @media (max-width: 1024px) {
    position: relative;
    right: 0px;
  } ;
`;

function PriceCard() {
  const {support_devices} = contents
  return (
    <CardContainer id="priceCard">
      <Section>
        <Title>SUPPORT DEVICE LIST</Title>
        <Annotation>*Keep updating for new devices</Annotation>
      </Section>
      <Cards grid_childs_number={support_devices.length}>
        {support_devices.map((device, index) => (
          <Card
            key={device.type}
            index={index}
            id={`price_card${index}`}
          >
            <Star/>
            <h1>{device.type}</h1>
            {device.device_models.map((model) => (
              <span key={model}>{model}</span>
            ))}
          </Card>
        ))}
      </Cards>
    </CardContainer>
  );
}

export default PriceCard;
